import React from 'react'
import { Link } from 'react-router-dom'
import abuso_sustancias from '../assets/images/psicologo/abuso_sustancias.jpg'
import Navbar from '../components/navbar'
import Shape from '../components/shape'
import ShapeTwo from '../components/shape-two'
import Footer from '../components/footer'
import bg_ansiedad from '../assets/images/psicologo/bg_ansiedad.jpg'
import bg1 from '../assets/images/bg.jpg'

export default function PageTerm() {
  return (
    <>
     <Navbar/>
     
    <section className="bg-half-170 bg-light d-table w-100" style={{backgroundImage:`url(${abuso_sustancias})`, backgroundPosition:'center'}}>
      <div className="bg-overlay"></div>
      <div className="container">
          <div className="row mt-5 text-center align-items-center">
              <div className="col-sm-6">
                  <div className="text-sm-start">
                      <div className="page-next-level">
                          <h4 className="title text-white">Abuso de sustancias</h4>
                          <p className="text-muted mb-0">Definición, síntomas y tratamientos</p>                                        
                      </div>
                  </div>
              </div>

              <div className="col-sm-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
                  <div className="page-next-level text-sm-end">
                      <ul className="page-next ps-0 mb-0">
                          <li className="list-inline-item"><Link to="/" className="fw-bold text-white">Inicio</Link></li>
                          <li className="list-inline-item"><Link to="#" className="fw-bold text-white">Lo que tratamos</Link></li>
                          <li className="list-inline-item">
                              <span className="text-primary fw-bold">Abuso de sustancias</span> 
                          </li> 
                      </ul>
                  </div>
              </div>
          </div>
      </div> 
    </section>
    <ShapeTwo/>
<section className="section">
  <div className="container">
    <div className="row justify-content-center" style={{textAlign:'justify', padding:20}}>
      <div className="col-12">
        <h4>Introducción</h4>
        <p className="text-muted">
          El abuso de sustancias implica un patrón de consumo problemático de drogas o alcohol que provoca deterioro o malestar significativo. Se caracteriza por la incapacidad para reducir o controlar el consumo, a pesar de conocer sus consecuencias negativas.
        </p>
        <br />
        <h4 className='text-warning'>¿Qué es el abuso de sustancias?</h4>
        <p className="text-muted">
          Se asocia con cambios en los circuitos cerebrales de recompensa y control de impulsos, particularmente en el sistema dopaminérgico. La neuromodulación busca restaurar la actividad normal de estas redes y reducir la necesidad compulsiva de consumir.
        </p>
        <br />
        <h4>Síntomas comunes</h4>
        <p className="text-muted">
          <i className="mdi mdi-chevron-double-right me-2"></i>
          Físicos: tolerancia a la sustancia, síntomas de abstinencia, deterioro de la salud física.
        </p>
        <p className="text-muted">
          <i className="mdi mdi-chevron-double-right me-2"></i>
          Cognitivos: pensamientos centrados en conseguir y consumir la sustancia, dificultad para tomar decisiones.
        </p>
        <p className="text-muted">
          <i className="mdi mdi-chevron-double-right me-2"></i>
          Conductuales: incumplimiento de responsabilidades, aislamiento social, conductas de riesgo.
        </p>
        <br />
        <h4>Neuromodulación</h4>
        <p className="text-muted">
          <i className="mdi mdi-chevron-double-right me-2"></i>
          Estimulación Magnética Transcraneal (EMT): estimulación en corteza prefrontal para reforzar el autocontrol y reducir la urgencia de consumo.
        </p>
        <p className="text-muted">
          <i className="mdi mdi-chevron-double-right me-2"></i>
          Estimulación Transcraneal por Corriente Directa (tDCS): modulación de redes de recompensa para disminuir la adicción.
        </p>
        <p className="text-muted">
          <i className="mdi mdi-chevron-double-right me-2"></i>
          Neurofeedback: entrenamiento para aumentar el control sobre impulsos y emociones.
        </p>
      </div>
    </div>
  </div>
</section>
    <Footer/>
    </>
  )
}
